import { render, staticRenderFns } from "./DyestuffForm1.vue?vue&type=template&id=1434acaf&scoped=true&"
import script from "./DyestuffForm1.vue?vue&type=script&lang=ts&"
export * from "./DyestuffForm1.vue?vue&type=script&lang=ts&"
import style0 from "./DyestuffForm1.vue?vue&type=style&index=0&id=1434acaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1434acaf",
  null
  
)

export default component.exports